$(document).ready(function() {
  var addtocartDisabled = $('#your_fav .ph-panel').find('.ph-panel-collapse .ph-addshoppinglisttocart');

  addtocartDisabled.attr('disabled', 'disabled').removeClass('ph-mylist__addtocart--enabled').addClass('ph-mylist__addtocart--disabled');

  $('.ph-panel-group').each(function() {
    if ($(this).find('.ph-openshoppinglist').text() !== '') {
      if ('#' + $(this).find('.ph-openshoppinglist').text().split(' ').join('').trim() === location.hash) {
        $(this).find('.ph-panel-collapse').toggleClass('ph-d-block');
      }
    }

    if (location.hash === '#favoriteList') {
      if ($(this).find('.ph-panel-title').text().split(' ').join('').trim() === 'MyList') {
        $(this).find('.ph-panel-collapse').toggleClass('ph-d-block');
      }
    }
  });
  $('.ph-panel-title').on('click', function() {
    var accordionParent = $(this).parents('.ph-panel'),
        isExpand = $(this).find('a').attr('aria-expanded'),
        accordionItem = accordionParent.find('input.ph-favqty[type="number"]'),
        favqty = ACC.editlistpopup.checkQty(accordionItem),
        addtocartButton = accordionParent.find('.ph-panel-collapse .ph-addshoppinglisttocart');

    accordionParent.find('.ph-panel-collapse').toggleClass('ph-d-block');
    accordionParent.siblings().find('.ph-panel-collapse').removeClass('ph-d-block');

    if (isExpand === 'true') {
      accordionParent.find('.ph-accordion-toggle').attr('aria-expanded', 'false');
      $(this).find('.ph-icon-arrow-up').addClass('ph-icon-arrow-down').removeClass('ph-icon-arrow-up');
    } else {
      accordionParent.find('.ph-accordion-toggle').attr('aria-expanded', 'true');
      $(this).find('.ph-icon-arrow-down').removeClass('ph-icon-arrow-down').addClass('ph-icon-arrow-up');
    }

    if (accordionParent.find('.ph-panel-collapse .ph-myfavshoppinglist .ph-favouriteslistmain').length === 0 || favqty === 0) {
      addtocartButton.attr('disabled', 'disabled').removeClass('ph-mylist__addtocart--enabled').addClass('ph-mylist__addtocart--disabled');
    } else {
      addtocartButton.removeAttr('disabled').removeClass('ph-mylist__addtocart--disabled').addClass('ph-mylist__addtocart--enabled');
    }
  });

  $('input.ph-favqty[type="number"]').on('keyup', function() {
    var qtyVal = parseInt($(this).val(), 10),
        qtyMin = parseInt($(this).attr('min'), 10),
        qtyMax = parseInt($(this).attr('max'), 10);

    if (qtyVal < qtyMin) {
      $(this).val(qtyMin);
    } else if (qtyVal > qtyMax) {
      $(this).val(qtyMax);
    }
  }).on('focus', function() {
    $(this).select();
  });

  $('.ph-qtyplus').click(function(e) {
    e.preventDefault();

    var fieldNamePlus = $(this).attr('field'),
        currentVal = parseInt($('input[name=' + fieldNamePlus + ']').val(), 10),
        maxValue = parseInt($('input[name=' + fieldNamePlus + ']').attr('max'), 10);

    if (maxValue > currentVal && $(this).parent().attr('data-isInnoSightWarranty') !== 'true') {
      $('input[name=' + fieldNamePlus + ']').val(currentVal + 1).trigger('blur');
    }
  });

  $('.ph-qtyminus').click(function(e) {
    e.preventDefault();

    var fieldNameMinus = $(this).attr('field'),
        currentVal = parseInt($('input[name=' + fieldNameMinus + ']').val(), 10),
        minValue = parseInt($('input[name=' + fieldNameMinus + ']').attr('min'), 10);

    if (minValue < currentVal && $(this).parent().attr('data-isInnoSightWarranty') !== 'true') {
      $('input[name=' + fieldNameMinus + ']').val(currentVal - 1).trigger('blur');
    }
  });
});
